export const apiHost = "https://api.happyvalley.com";
export const baseUrl = "https://api.happyvalley.com";
///export const apiHost = "https://api-test.happyvalley.com";
///export const baseUrl = "https://api-test.happyvalley.com";
///export const apiHost = "https://happyvalley-api.test";
///export const baseUrl = "https://happyvalley-api.test";
export const recaptchaKey = "6LdhZHwpAAAAADKjDSsePr4h0vNyt3pKmc23ttB-";